module.exports = __webpack_public_path__ + "img/powered-by-google.17d5f45a.png";